import styles from './tournaments-list-page.module.css'
import {
  DataGrid
} from 'widgets/data-grid'
import { SyntheticEvent, useCallback, useEffect, useState } from 'react'
import { TournamentManipulationService } from 'shared/tournaments/services/tournament-manipulation-service'
import { type TTournament, type TTournamentDeleteMessage } from '../types'

import { useNavigate } from 'react-router-dom'
import { redirectIfNoRefreshToken } from 'shared/redirects'
import { columns, mapDispatchToProps, mapStateToProps } from '../maps'
import { connect, useDispatch } from 'react-redux'
import { IconMenu } from 'widgets/icon-menu'
import { SearchPanel } from 'widgets/search-bar/SearchPanel'
import { type TSearchQuery } from 'widgets/search-bar/types'
import { searchFilter } from 'widgets/search-bar/search-service'
import { clearEditableTournament, setEditableTournamentFields } from 'app/store/slices/editableTournament'
import { IsAdmin } from 'shared/checkUser'
import { loadTournamentsSaga } from 'app/store/sagas/root'
import { showErrorMessage, clearErrorMessage, clearInfoMessage, showInfoMessage } from 'app/store/slices/alerts'
import { setCountTournaments } from 'app/store/slices/tournaments'
import { InputBase } from '@mui/material'
import { useDebounce } from 'shared/useDebaunce'
import { TournamentsList } from './tournaments-list'
import { PerPageCount } from 'widgets/data-grid/components/PerPageCount/PerPageCount'
import { TableArrows } from 'widgets/data-grid/components/TableArrows/TableArrows'
import { PerPageSelector } from 'widgets/data-grid/components/PerPageSelector/PerPageSelector'

const tournamentManipulationService = TournamentManipulationService()

export const TournamentsListPage: any = connect(mapStateToProps, mapDispatchToProps)(function ({
  count,
  tournaments,
  selectedTournaments,
  setTournaments,
  setSelectedTournaments
}: any) {
  const [searchQuery, setSearchQuery] = useState<TSearchQuery[]>([])
  const [page, setPage] = useState<number>(0)
  const [perPageCount, setPerPageCount] = useState<number>(10)
  const [textQuery, setTextQuery] = useState('')
  const debouncedSearchTerm = useDebounce(textQuery, 500);
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const loadWholeTournaments = async () => {
    
    const tournaments = await tournamentManipulationService.takeWholeTournaments()

    if (tournaments.errorMessage) {
      dispatch(showErrorMessage(tournaments.errorMessage))
      setTimeout(() => { dispatch(clearErrorMessage()) }, 5000); return
    }
    setTournaments(tournaments.tournaments || [])
  }

  useEffect(() => {
    // loadTournamentsSaga()
    redirectIfNoRefreshToken(navigate)
  }, [])

  useEffect(() => {
    setPage(0)
  }, [perPageCount])

  const onSearchQueryChange = useCallback(async (query: TSearchQuery, page: number, perPageCount: number) => {
    if (query.value !== '') {
      const {count} = await tournamentManipulationService.getCountTournamentsField(query.field, query.value)
      dispatch(setCountTournaments(count))
      const {tournaments} = await tournamentManipulationService.getTournamentsField(query.field, query.value, page, perPageCount)
      dispatch(setTournaments(tournaments || []))
    } else {
      const {count} = await tournamentManipulationService.getCountTournaments()
      dispatch(setCountTournaments(count))
      const {tournaments} = await tournamentManipulationService.getTournaments(page, perPageCount)
      dispatch(setTournaments(tournaments || []))
    }
    // setSearchQuery(query)
  }, [])

  const onRowDblClick = (target: any) => {
    // const target = tournaments.find((el: any) => el.id === tournamentId)
    if (!target) {
      return
    }
    // console.log('target: ', target)
    // dispatch(setEditableTournamentFields(target))
    navigate(`/tournaments/create?regime=update&id=${target}`)
  }

  const onCreateCLick = () => {
    dispatch(clearEditableTournament())
    navigate('/tournaments/create')
  }

  useEffect(() => {
    if(debouncedSearchTerm === "") {
      onSearchQueryChange({
        value: '',
        field: '',
        equivalence: ''
      }, page, perPageCount)
      return
    }
    onSearchQueryChange({
      value: debouncedSearchTerm,
      field: 'name',
      equivalence: ''
    }, page, perPageCount)
  }, [debouncedSearchTerm, page, perPageCount])

  return <div className={styles.TournamentPage}>
    <IconMenu onCreateClick={onCreateCLick} />
    <InputBase
      placeholder={`Поиск по названию`}
      inputProps={{ 'aria-label': 'search by name' }}
      onChange={(e: SyntheticEvent<HTMLInputElement | HTMLTextAreaElement>) => { setTextQuery(e.currentTarget.value) }}
    />
    <TournamentsList tournaments={tournaments} onDoubleClick={onRowDblClick}/>
    <div className={styles.SearchQuery}>
      <PerPageCount variants={[10, 20, 30]} onChange={(pageCount: number) => setPerPageCount(pageCount)} />
      <PerPageSelector
        startIndex={page * perPageCount}
        endIndex={(page + 1) * perPageCount}
        wholeLength={count || 0}
      />
      <TableArrows onLeftClick={() => setPage((page) => (page === 0 ? page : page - 1))} onRightClick={() => setPage((page) => ((page + 1) * perPageCount >= count ? page :page + 1))}/>
    </div>
  </div>
})
